import Icon from "@Atom/Icon";
import Styles from "./styles.module.scss";
import { useEffect, useMemo, useRef, useState } from "react";
import FirstStep from "./First";
import SecondStep from "./Second";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import ThirdStep from "./Third";
import { useLocation, useNavigate } from "react-router-dom";
import draftToHtml from "draftjs-to-html";
import { editJobPostClient, upladJobPostClient } from "@Services/home";
import moment from "moment";
import ModalWrapper from "@Atom/ModalWrapper";
import Images from "@Theme/Images";
import useQuery from "@Hooks/useQuery";
import htmlToDraft from "html-to-draftjs";

export default function JobForm({ getDropdownList, getDetailJobPost = null }) {
  const [step, setStep] = useState(
    +sessionStorage?.getItem("stepCreateJobClient") || 1
  );

  const query = useQuery();

  const navigate = useNavigate();

  const { pathname } = useLocation();

  const targetElement = useRef();

  const scrollingTop = (event) => {
    const elmnt = targetElement;
    elmnt.current.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "start",
    });
  };

  useEffect(() => {
    navigate(
      `${pathname}?id=${query?.get("id") || ""}&fr=${query?.get("fr") || ""}`,
      {
        replace: true,
      }
    );
  }, [navigate, pathname, query]);

  const [loading, setLoading] = useState("");
  const [validate, setValidate] = useState(false);

  const defaultFirstStep = JSON.parse(
    sessionStorage.getItem(`firstStepJobClient`)
  );

  const [firstStep, setFirstStep] = useState({
    positionName:
      defaultFirstStep?.positionName || getDetailJobPost?.response?.title || "",
    categoryPosition:
      defaultFirstStep?.categoryPosition ??
      (getDetailJobPost?.response?.categories?.length > 0
        ? getDetailJobPost?.response?.categories[0]?.value
        : ""),
    location:
      defaultFirstStep?.location ??
      (getDetailJobPost?.response?.placement?.length > 0
        ? getDetailJobPost?.response?.placement[0]?.city
        : ""),
    cityCode:
      defaultFirstStep?.cityCode ??
      (getDetailJobPost?.response?.placement?.length > 0
        ? getDetailJobPost?.response?.placement[0]?.code
        : ""),
    workplaceType:
      defaultFirstStep?.workplaceType ||
      getDetailJobPost?.response?.workMethod ||
      "",
    employeeStatus:
      defaultFirstStep?.employeeStatus ||
      getDetailJobPost?.response?.workSystem ||
      "",
    minSalary:
      defaultFirstStep?.minSalary ??
      (getDetailJobPost?.response?.salary?.includes("-")
        ? getDetailJobPost?.response?.salary?.split("-")[0].trim()
        : ""),
    maxSalary:
      defaultFirstStep?.maxSalary ??
      (getDetailJobPost?.response?.salary?.includes("-")
        ? getDetailJobPost?.response?.salary?.split("-")[1].trim()
        : ""),
    showSalary:
      defaultFirstStep?.showSalary ||
      getDetailJobPost?.response?.isSalaryDisplay ||
      false,
    photoCandidate:
      defaultFirstStep?.photoCandidate ??
      (getDetailJobPost
        ? getDetailJobPost?.response?.isPhotoDisplay
          ? "yes"
          : "no"
        : ""),
    videoCandidate:
      defaultFirstStep?.videoCandidate ??
      (getDetailJobPost
        ? getDetailJobPost?.response?.isSelfIntroVidDisplay
          ? "yes"
          : "no"
        : ""),
  });

  const isHtml = (str) => {
    const doc = new DOMParser().parseFromString(str, "text/html");
    return Array.from(doc.body.childNodes).some((node) => node.nodeType === 1);
  };

  const convertToEditorState = (input) => {
    if (isHtml(input)) {
      const contentBlock = htmlToDraft(input);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks,
          contentBlock.entityMap
        );
        return EditorState.createWithContent(contentState);
      }
    } else {
      const contentState = ContentState.createFromText(input || "");
      return EditorState.createWithContent(contentState);
    }

    // Fallback jika semuanya gagal
    return EditorState.createEmpty();
  };

  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );

  useEffect(() => {
    const titleFromBackend = getDetailJobPost?.response?.description;
    if (titleFromBackend !== undefined) {
      const newEditorState = convertToEditorState(titleFromBackend);
      setEditorState(newEditorState);
    }
  }, [getDetailJobPost?.response?.description]);

  const defaultThirdStep = JSON.parse(
    sessionStorage.getItem(`thirdStepJobClient`)
  );

  const evaluationsDefault = useMemo(() => {
    if (
      getDetailJobPost &&
      getDetailJobPost?.response?.evaluations?.length > 0
    ) {
      return getDetailJobPost?.response?.evaluations?.map((el) => {
        return {
          idUpdate: el?._id,
          name: el?.label,
          action: "UPDATE",
        };
      });
    } else {
      return [];
    }
  }, [getDetailJobPost]);

  const questionsDefault = useMemo(() => {
    if (getDetailJobPost && getDetailJobPost?.response?.questions?.length > 0) {
      return getDetailJobPost?.response?.questions?.map((el, idx) => {
        return {
          idUpdate: "",
          id: idx + 1,
          action: "UPDATE",
          question: el?.label || "",
          answer:
            el?.type === "Tanggal"
              ? {
                  minDate: el?.answer?.value?.split("-")[0]?.trim(),
                  maxDate: el?.answer?.value?.split("-")[1]?.trim(),
                }
              : el?.answer?.value || "",
          type: el?.type || "Isian Singkat",
          required: el?.answerRequired || false,
          optionAnswers:
            el?.type === "Pilihan"
              ? el?.answerOptions?.length
                ? el?.answerOptions?.map((el) => {
                    return {
                      name: el?.value,
                      id: el?.no,
                    };
                  })
                : []
              : [],
        };
      });
    } else {
      return [];
    }
  }, [getDetailJobPost]);

  const [thirdStep, setThirdStep] = useState({
    skills: defaultThirdStep?.skills || evaluationsDefault || [],
    experiences:
      defaultThirdStep?.experiences ||
      getDetailJobPost?.response?.experience ||
      "",
    educations:
      defaultThirdStep?.educations ||
      getDetailJobPost?.response?.requirements
        ?.find((requirement) =>
          requirement.value.includes("Pendidikan terakhir")
        )
        ?.value?.split(":")[1]
        ?.trim() ||
      "",
    questions: defaultThirdStep?.questions || questionsDefault || [],
  });

  useEffect(() => {
    sessionStorage?.setItem("stepCreateJobClient", step || 1);
    sessionStorage?.setItem("firstStepJobClient", JSON.stringify(firstStep));
    sessionStorage?.setItem("thirdStepJobClient", JSON.stringify(thirdStep));
  }, [step, firstStep, thirdStep]);

  // const rawContentState = convertToRaw(editorState.getCurrentContent());
  // const htmlString = draftToHtml(rawContentState);

  const stepOption = [
    {
      name: "Informasi Umum",
      id: 1,
    },
    {
      name: "Deskripsi Pekerjaan",
      id: 2,
    },
    {
      name: "Kriteria Kandidat",
      id: 3,
    },
  ];

  const contentStep = useMemo(() => {
    switch (step) {
      case 1:
        return (
          <FirstStep
            firstStep={firstStep}
            setFirstStep={setFirstStep}
            validate={validate}
            getDropdownList={getDropdownList?.response}
          />
        );

      case 2:
        return (
          <SecondStep
            editorState={editorState}
            setEditorState={setEditorState}
            validate={validate}
          />
        );

      case 3:
        return (
          <ThirdStep
            thirdStep={thirdStep}
            setThirdStep={setThirdStep}
            validate={validate}
          />
        );

      default:
        break;
    }
  }, [
    step,
    firstStep,
    setFirstStep,
    validate,
    editorState,
    setEditorState,
    thirdStep,
    setThirdStep,
    getDropdownList,
  ]);

  const disableStepOne = useMemo(() => {
    if (!firstStep?.positionName) {
      return true;
    }

    if (!firstStep?.categoryPosition) {
      return true;
    }

    if (!firstStep?.location) {
      return true;
    }

    if (!firstStep?.workplaceType) {
      return true;
    }

    if (!firstStep?.employeeStatus) {
      return true;
    }
    if (!firstStep?.minSalary) {
      return true;
    }

    if (!firstStep?.maxSalary) {
      return true;
    }

    if (
      firstStep?.minSalary &&
      firstStep?.maxSalary &&
      +firstStep?.maxSalary < +firstStep?.minSalary
    ) {
      return true;
    }

    if (!firstStep?.photoCandidate) {
      return true;
    }
    if (!firstStep?.videoCandidate) {
      return true;
    }

    return false;
  }, [firstStep]);

  const disableStepTwo = useMemo(() => {
    if (!firstStep?.positionName) {
      return true;
    }

    if (!firstStep?.categoryPosition) {
      return true;
    }

    if (!firstStep?.location) {
      return true;
    }

    if (!firstStep?.workplaceType) {
      return true;
    }

    if (!firstStep?.employeeStatus) {
      return true;
    }
    if (!firstStep?.minSalary) {
      return true;
    }

    if (!firstStep?.maxSalary) {
      return true;
    }
    if (!firstStep?.photoCandidate) {
      return true;
    }
    if (!firstStep?.videoCandidate) {
      return true;
    }

    if (!editorState.getCurrentContent().getPlainText().trim()) {
      return true;
    }

    return false;
  }, [firstStep, editorState]);

  const disabledThird = useMemo(() => {
    if (!editorState.getCurrentContent().getPlainText().trim()) {
      return true;
    }

    if (
      thirdStep?.skills?.filter((el) => el?.action !== "DELETE")?.length === 0
    ) {
      return true;
    }

    if (!thirdStep?.experiences) {
      return true;
    }
    if (!thirdStep?.educations) {
      return true;
    }

    if (
      thirdStep?.questions?.filter((op) => op?.action !== "DELETE").length > 0
    ) {
      const filteredQuestion = thirdStep?.questions?.filter(
        (op) => op?.action !== "DELETE"
      );
      for (let index = 0; index < filteredQuestion?.length; index++) {
        const element = filteredQuestion[index];
        if (!element?.question) {
          return true;
        }

        if (!element?.type) {
          return true;
        }

        if (
          ["Pilihan", "Numerik"].includes(element?.type) &&
          !element?.answer
        ) {
          return true;
        }

        if (
          element?.type === "Pilihan" &&
          element?.optionAnswers?.filter((op) => op?.action !== "DELETE")
            ?.length < 2
        ) {
          return true;
        }

        if (
          element?.type === "Tanggal" &&
          (!element?.answer?.minDate || !element?.answer?.maxDate)
        ) {
          return true;
        }

        if (
          element?.type === "Pilihan" &&
          element?.optionAnswers?.filter((op) => op?.action !== "DELETE")
            ?.length > 0
        ) {
          const filterOptions = element?.optionAnswers?.filter(
            (op) => op?.action !== "DELETE"
          );

          for (let j = 0; j < filterOptions.length; j++) {
            const elementJ = filterOptions[j];

            if (!elementJ?.name) {
              return true;
            }

            // return false;
          }
        }
        // return false;
      }

      return false;
    }

    return false;
  }, [thirdStep, editorState]);

  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e, type = "") => {
    e.preventDefault();
    try {
      setLoading(type === "Draft" ? type : "Publish");

      const rawContentState = convertToRaw(editorState.getCurrentContent());
      const htmlString = draftToHtml(rawContentState);

      const payload = {
        ...(query?.get("id") && !type
          ? { status: "Publish" }
          : type === "Draft" && { status: "Draft" }), // <--- ini dia
        title: firstStep?.positionName || "",
        category: firstStep?.categoryPosition || "",
        cityCode: firstStep?.cityCode || "",
        workMethod: firstStep?.workplaceType || "",
        workSystem: firstStep?.employeeStatus || "",
        lowestSalary: firstStep?.minSalary || "",
        highestSalary: firstStep?.maxSalary || "",
        isSalaryDisplay: firstStep?.showSalary || false,
        isPhotoDisplay:
          firstStep?.photoCandidate?.toLowerCase() === "yes" ? true : false,
        isSelfIntroVidDisplay:
          firstStep?.videoCandidate?.toLowerCase() === "yes" ? true : false,
        description: !editorState.getCurrentContent().getPlainText().trim()
          ? ""
          : htmlString,
        evaluations:
          thirdStep?.skills?.filter((el) => el?.action !== "DELETE")?.length > 0
            ? thirdStep?.skills
                ?.filter((el) => el?.action !== "DELETE")
                ?.map((el) => el?.name)
            : [],

        experience: thirdStep?.experiences || "",
        education: thirdStep?.educations || "",
        questions:
          thirdStep?.questions?.filter((op) => op?.action !== "DELETE")
            ?.length > 0
            ? thirdStep?.questions
                ?.filter((op) => op?.action !== "DELETE")
                ?.map((el) => {
                  if (el?.type === "Isian Singkat") {
                    return {
                      label: el?.question,
                      type: el?.type,
                      answer: el?.answer || "",
                      answerRequired: el?.required,
                    };
                  } else if (el?.type === "Paragraf") {
                    return {
                      label: el?.question,
                      type: el?.type,
                      answer: el?.answer || "",
                      answerRequired: el?.required,
                    };
                  } else if (el?.type === "Numerik") {
                    return {
                      label: el?.question,
                      type: el?.type,
                      answer: el?.answer || "",
                      answerRequired: el?.required,
                    };
                  } else if (el?.type === "Tanggal") {
                    return {
                      answerRequired: el?.required,
                      label: el?.question,
                      type: el?.type,
                      startDate: el?.answer?.minDate
                        ? moment(new Date(el?.answer?.minDate))?.format(
                            "YYYY-MM-DD"
                          )
                        : "",
                      endDate: el?.answer?.maxDate
                        ? moment(new Date(el?.answer?.maxDate))?.format(
                            "YYYY-MM-DD"
                          )
                        : "",
                    };
                  } else if (el?.type === "Pilihan") {
                    return {
                      answerRequired: el?.required,
                      label: el?.question,
                      type: el?.type,
                      answer: el?.answer || "",
                      answerOptions: el?.optionAnswers
                        ?.filter((ansOpt) => ansOpt?.action !== "DELETE")
                        ?.map((item) => item?.name),
                    };
                  } else {
                    return {
                      label: el?.question,
                      type: el?.type,
                      answer: el?.answer || "",
                      answerRequired: el?.required,
                    };
                  }
                })
            : [],
      };

      if (type === "Draft") {
        if (
          !firstStep?.positionName ||
          !firstStep?.categoryPosition ||
          (firstStep?.minSalary &&
            firstStep?.maxSalary &&
            +firstStep?.maxSalary < +firstStep?.minSalary)
        ) {
          setValidate(true);
          scrollingTop();
        } else {
          setValidate(false);
          query?.get("id")
            ? await editJobPostClient(query?.get("id"), payload)
            : await upladJobPostClient(payload);
          setSuccess(true);
          sessionStorage?.clear();
        }
      } else {
        if (step === 1) {
          if (disableStepOne) {
            setValidate(true);
            scrollingTop();
          } else {
            setStep((prev) => prev + 1);
            setValidate(false);
          }
        } else if (step === 2) {
          if (disableStepTwo) {
            setValidate(true);
            scrollingTop();
          } else {
            setStep((prev) => prev + 1);
            setValidate(false);
          }
        } else if (step === 3) {
          if (disabledThird) {
            setValidate(true);
            scrollingTop();
          } else {
            setValidate(false);
            query?.get("id")
              ? await editJobPostClient(query?.get("id"), payload)
              : await upladJobPostClient(payload);
            setSuccess(true);
            sessionStorage?.clear();
          }
        }
      }

      setLoading("");
      setError("");
    } catch (error) {
      setError(error.response?.data?.error);
      setLoading("");
      setValidate(false);
      console.log(error);
      setSuccess(false);
    }
  };

  return (
    <div className={Styles.container}>
      <div>
        <div className={Styles.autoScroll} ref={targetElement} />
        <div
          className={Styles.header}
          onClick={() => {
            navigate(
              query?.get("fr")
                ? `/business/dashboard/job-list/${query?.get("id")}`
                : `/business/dashboard/job-list`
            );
            sessionStorage?.clear();
          }}
        >
          <div>
            <Icon icon={"arrow-left"} size={24} color={"#FFFFFF"} />
          </div>
          <span>Buat Loker Baru</span>
        </div>

        <div className={Styles.content}>
          <div className={Styles.stepper}>
            {stepOption?.map((el) => {
              return (
                <div
                  key={el?.id}
                  className={`${step === el?.id && Styles.active}`}
                  onClick={(e) => {
                    if (el?.id < step) {
                      setStep(el?.id);
                    } else {
                      if (step !== 3) {
                        handleSubmit(e, "");
                      }
                    }
                  }}
                >
                  {(!disableStepOne && el?.id === 1) ||
                  (!disableStepTwo && el?.id === 2) ||
                  (!disabledThird && el?.id === 3) ? (
                    <div className={Styles.iconCheck}>
                      <Icon icon={"check-circle-2"} size={16} color={"#fff"} />
                    </div>
                  ) : (
                    <div className={Styles.number}>{el?.id}</div>
                  )}

                  <div className={Styles.title}>{el?.name}</div>
                </div>
              );
            })}
          </div>

          <div className={Styles.formBox}>{contentStep}</div>

          <div className={Styles.buttonWrapper}>
            {/* <span>*error</span> */}
            {error && <span>*{error}</span>}
            <div className={Styles.button}>
              {getDetailJobPost?.response?.status !== "Publish" ? (
                <button
                  disabled={loading}
                  onClick={(e) => handleSubmit(e, "Draft")}
                >
                  {loading === "Draft" ? "Loading..." : "Simpan Sebagai Draft"}
                </button>
              ) : (
                <div></div>
              )}

              <div>
                <button
                  disabled={loading}
                  onClick={() => {
                    navigate(
                      query?.get("fr")
                        ? `/business/dashboard/job-list/${query?.get("id")}`
                        : `/business/dashboard/job-list`
                    );
                    sessionStorage?.clear();
                  }}
                >
                  Batal
                </button>
                <button disabled={loading} onClick={(e) => handleSubmit(e, "")}>
                  {loading === "Publish"
                    ? "Loading..."
                    : step === 3
                    ? "Unggah Lowongan Pekerjaan"
                    : "Lanjut"}
                </button>
              </div>
            </div>
          </div>
        </div>

        {success && (
          <ModalWrapper show={success} handleClose={() => {}}>
            <div className={Styles.modalSuccesContainer}>
              <div className={Styles.headerModal}>
                <span className={Styles.titleHeader}>
                  Lowongan Kerja Berhasil Dibuat
                </span>
                <Icon
                  icon={"cross"}
                  size={20}
                  color={"#0A0A0A"}
                  className={Styles.cross}
                  onClick={() => setSuccess(false)}
                />
              </div>

              <div className={Styles.imagesModal}>
                <img src={Images.SUCCESS_IMAGE_CLIENT} alt="" />
              </div>
              <span>
                Lowongan pekerjaan telah berhasil dibuat, tim kami akan meninjau
                terlebih dahulu sebelum lowongan pekerjaan Anda aktif
              </span>
              <button
                onClick={() => {
                  setSuccess(false);
                  navigate(
                    query?.get("fr")
                      ? `/business/dashboard/job-list/${query?.get("id")}`
                      : `/business/dashboard/job-list`
                  );
                }}
              >
                Kembali Ke Daftar Loker
              </button>
            </div>
          </ModalWrapper>
        )}
      </div>
    </div>
  );
}
